export type AriaProps = {
  accessibleLabel?: string;
  ariaLabelledBy?: string;
};

const ariaInterpolations = {
  accessibleLabel: ({ accessibleLabel }: Pick<AriaProps, 'accessibleLabel'>) =>
    accessibleLabel === undefined
      ? {}
      : {
          ariaLabel: accessibleLabel
        },
  ariaLabelledBy: ({ ariaLabelledBy }: Pick<AriaProps, 'ariaLabelledBy'>) =>
    ariaLabelledBy === undefined
      ? {}
      : {
          ariaLabelledBy
        }
};

export { ariaInterpolations };
